import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

const canAccessLabelSettings = (userRole, features) => {
  if (
    userRole === 'administrator' ||
    userRole === 'master' ||
    userRole === 'supervisor'
  )
    return true;

  if (userRole === 'agent')
    return features && features[FEATURE_FLAGS.AGENT_LABEL_MANAGEMENT];

  return false;
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_MGMT.HEADER',
        icon: 'tag',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          roles: ['administrator', 'master', 'supervisor', 'agent'],
          roleValidator: canAccessLabelSettings,
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          roles: ['administrator', 'master', 'supervisor', 'agent'],
          roleValidator: canAccessLabelSettings,
          component: Index,
        },
      ],
    },
  ],
};
